module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/main/main.component.css
// module id = ./src/app/components/main/main.component.css
// module chunks = main